/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunnelDiscountDto } from './FunnelDiscountDto';
import {
    FunnelDiscountDtoFromJSON,
    FunnelDiscountDtoFromJSONTyped,
    FunnelDiscountDtoToJSON,
    FunnelDiscountDtoToJSONTyped,
} from './FunnelDiscountDto';

/**
 * 
 * @export
 * @interface BorrowerLoanPricingDto
 */
export interface BorrowerLoanPricingDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerLoanPricingDto
     */
    id: string;
    /**
     * 
     * @type {FunnelDiscountDto}
     * @memberof BorrowerLoanPricingDto
     */
    pricing: FunnelDiscountDto;
}

/**
 * Check if a given object implements the BorrowerLoanPricingDto interface.
 */
export function instanceOfBorrowerLoanPricingDto(value: object): value is BorrowerLoanPricingDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    return true;
}

export function BorrowerLoanPricingDtoFromJSON(json: any): BorrowerLoanPricingDto {
    return BorrowerLoanPricingDtoFromJSONTyped(json, false);
}

export function BorrowerLoanPricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerLoanPricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pricing': FunnelDiscountDtoFromJSON(json['pricing']),
    };
}

export function BorrowerLoanPricingDtoToJSON(json: any): BorrowerLoanPricingDto {
    return BorrowerLoanPricingDtoToJSONTyped(json, false);
}

export function BorrowerLoanPricingDtoToJSONTyped(value?: BorrowerLoanPricingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'pricing': FunnelDiscountDtoToJSON(value['pricing']),
    };
}

